// constants.js
export const DEFAULT_BREAKPOINT_SIZES = {
  mobile: 0,
  tablet: 768,
  desktop: 1024
}
